import { useAudioState } from "@/features/telephony/providers/telephony-context";

export const useCapabilities = () => {
    const { capabilities } = useAudioState();
    return capabilities;
};
